'use strict';

angular.module('itPurchasingControllers')

.controller('ItPurchasingAssignController', ['$scope', '$modal', 'growl', 'ITPurchasingService', 'searchService', function ($scope, $modal, growl, ITPurchasingService, searchService) {

    $scope.refreshEmployees = function (searchTerm) {
        if (searchTerm.length < 3) return;
        return searchService.searchActiveEmployees(searchTerm)
                            .then(function (employees) {
                                $scope.employees = employees;
                            });
    };

    /* Assign Employee */
    $scope.manageAssignEmployee = function () {

        var assignModal = $modal({
            scope: $scope.$new(false),
            template: require('./itPurchasingAssign.tpl.html'),
            placement: 'center'
        });

        $scope.hideModal = function () {
            assignModal.$promise.then(assignModal.hide);
        };

        var updateRequest = function (updatedRequest) {

            if (_.isUndefined($scope.selectedCard.AssignedTo)) {
                $scope.nbCards.NbToAssign -= 1;
                $scope.nbCards.NbToAuthorize += 1;
            }

            var updatedSysEmp = updatedRequest.SystemsAndEmployees[0];
            $scope.selectedCard.AssignedTo = updatedSysEmp.AssignedTo;
            $scope.selectedCard.AssignedToActiveDirectoryAccountUsername = updatedSysEmp.AssignedToActiveDirectoryAccountUsername;
            $scope.selectedCard.AssignedToUrlImage = updatedSysEmp.AssignedToUrlImage;

            $scope.hideModal();
        };

        $scope.assignToMe = function () {
            ITPurchasingService.assignToCurrentUser($scope.selectedCard)
                               .then(updateRequest);
        };

        $scope.assignToEmployee = function () {
            ITPurchasingService.assignToEmployee($scope.selectedCard,
                                                 $scope.selectedCard.AssignToObject.EmployeeID)
                               .then(updateRequest);
        };
    }
}]);
